module.exports = __webpack_public_path__ + "img/chef.10dcd37e.png";